import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useGetMeApi } from 'eds-common/api/v2';
import { fetchEntitlements } from '@/services/fulfillment/fetchEntitlements';

export function entitlementsQuery(userId?: string) {
  return {
    queryKey: ['entitlements', userId],
    queryFn: () => fetchEntitlements(userId),
    staleTime: Infinity,
  } satisfies UseQueryOptions;
}

export function useEntitlements() {
  const { data: user } = useGetMeApi();
  return { entitlements: useQuery(entitlementsQuery(user?.userId)).data };
}
